import { render, staticRenderFns } from "./PromoOverviewMetrics.vue?vue&type=template&id=1d6e6222&scoped=true&"
import script from "./PromoOverviewMetrics.vue?vue&type=script&lang=js&"
export * from "./PromoOverviewMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e6222",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})
